module.exports = __webpack_public_path__ + "img/insuranceee.f211ae2c.png";